import { Component, Input } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import {
  EmperorThemeColor,
  EmperorUIButtonTypes,
} from '@boldpenguin/emperor-presentational';

@Component({
  selector: 'app-npn-input',
  templateUrl: './npn-input.component.html',
  styleUrls: ['./npn-input.component.scss'],
})
export class NpnInputComponent {
  @Input() label: string;
  @Input() isReadOnly = false;
  @Input() isOptional = false;
  @Input() set npnControl(control: UntypedFormControl) {
    if (control) {
      this.formControl = control;
      this.formControl.addValidators([
        Validators.minLength(5),
        Validators.maxLength(10),
      ]);
      this.formControl.updateValueAndValidity();
    }
  }

  formControl: UntypedFormControl;
  readonly textButton = EmperorUIButtonTypes.Text;
  readonly EmperorThemeColor = EmperorThemeColor;

  readonly npnMask = { mask: Number, scale: 0 };
  readonly npnErrorMessage = 'NPN must be between 5 and 10 characters.';
  readonly hintText =
    "NPN and license numbers are different. If you need help, use the <a target='_blank' href='https://nipr.com/help/look-up-your-npn'>NPN lookup tool</a>.";
  readonly npnErrorMessageMap = {
    minlength: this.npnErrorMessage,
    maxlength: this.npnErrorMessage,
  };
}
